import React, { useState } from "react";
import Hero from "../components/hero";
import Card from "../components/card";
import CardContainer from "../components/cardcontainer";
import SectionHeading from "../components/sectionheading";
import Footer from "../components/footer";
import ShapesBackground from "../components/shapesbackground";
import { useLang } from "../context/langcontext";

// --------------------
// Import vendor logos
// --------------------
import almlasLogo from "../assets/vendors/almlas.png";
import alraisiLogo from "../assets/vendors/alraisi.png";
import awaniLogo from "../assets/vendors/awani.png";
import bandarLogo from "../assets/vendors/bandar.png";
import benLogo from "../assets/vendors/ben.png";
import butcherLogo from "../assets/vendors/butcher.png";
import chubzzLogo from "../assets/vendors/chubzz.png";
import grillLogo from "../assets/vendors/grill.png";
import halaLogo from "../assets/vendors/hala.png";
import hbLogo from "../assets/vendors/hb.png";
import jalalLogo from "../assets/vendors/jalal.png";
import mahshyLogo from "../assets/vendors/mahshy.png";
import mdmsLogo from "../assets/vendors/mdms.png";
import nutfitLogo from "../assets/vendors/nutfit.png";
import pizzaloverLogo from "../assets/vendors/pizzalover.png";
import rosesLogo from "../assets/vendors/roses.png";

// --------------------
// Vendors Data
// --------------------
const vendorsData = [
  { id: 1, key: "vendorALMLAS", category: "restaurants", logo: almlasLogo },
  { id: 2, key: "vendorAlRaisi", category: "grocery", logo: alraisiLogo },
  { id: 3, key: "vendorAwaniHouse", category: "kitchen_utensils", logo: awaniLogo },
  { id: 4, key: "vendorAlBandar", category: "restaurants", logo: bandarLogo },
  { id: 5, key: "vendorBenDawla", category: "dessert", logo: benLogo },
  { id: 6, key: "vendorOmanButchery", category: "meat", logo: butcherLogo },
  { id: 7, key: "vendorChubbz", category: "restaurants", logo: chubzzLogo },
  { id: 8, key: "vendorGrillKingdom", category: "restaurants", logo: grillLogo },
  { id: 9, key: "vendorHala", category: "bakery", logo: halaLogo },
  { id: 10, key: "vendorHB", category: "drinks", logo: hbLogo },
  { id: 11, key: "vendorJalalEfendi", category: "cafe", logo: jalalLogo },
  { id: 12, key: "vendorHikaytMahshi", category: "restaurants", logo: mahshyLogo },
  { id: 13, key: "vendorMedames", category: "restaurants", logo: mdmsLogo },
  { id: 14, key: "vendorNutritionFit", category: "health_nutrition", logo: nutfitLogo },
  { id: 15, key: "vendorPizzaLover", category: "restaurants", logo: pizzaloverLogo },
  { id: 16, key: "vendorRoses", category: "flowers_gifts", logo: rosesLogo },
];

// --------------------
// Categories
// --------------------
const categories = [
  "all",
  "restaurants",
  "fruitsVeg",
  "grocery",
  "meat",
  "chicken",
  "fishSeafood",
  "nuts",
  "spicesCoffee",
  "bakery",
  "cafe",
  "pharmacies",
  "clothes",
  "perfumes",
  "cosmetics",
  "laundry",
  "hotelReservations",
  "rentCars",
  "taxi",
  "health_nutrition",
  "flowers_gifts",
  "dessert",
];

const Vendors = () => {
  const { t } = useLang();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");

  // --------------------
  // Filter vendors by category and search
  // --------------------
  const filteredVendors = vendorsData.filter((vendor) => {
    const matchesCategory = selectedCategory === "all" || vendor.category === selectedCategory;
    const matchesSearch = t(vendor.key).toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // --------------------
  // Get category label
  // --------------------
  const getCategoryLabel = (cat) => {
    if (cat === "all") return t("all");
    // first try new translation key (no prefix), then try old key (with 'category' prefix)
    const label = t(cat);
    if (label && label !== cat) return label;
    return t(`category${cat}`);
  };

  return (
    <>
      <ShapesBackground />

      <Hero
        heroImage={require("../assets/phone/vendor.png")}
        customHeading={t("vendorsHeroHeading")}
        customSubtext={t("vendorsCustomSubtext")}
        customDescription={t("vendorsHeroDescription")}
        showButtons={true}
      />

      <section className="vendors-page" id="vendors-page">
        <SectionHeading text={t("vendorsTitle") || "Our Vendors"} />

        <div className="search-bar">
          <input
            type="text"
            placeholder={t("searchVendors") || "Search vendors..."}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="categories-filter">
          {categories.map((cat) => (
            <button
              key={cat}
              className={selectedCategory === cat ? "active" : ""}
              onClick={() => setSelectedCategory(cat)}
            >
              {getCategoryLabel(cat)}
            </button>
          ))}
        </div>

        <CardContainer ignoreMatchHeight={true}>
          {filteredVendors.length > 0 ? (
            filteredVendors.map((vendor) => (
              <Card key={vendor.id}>
                <img
                  src={vendor.logo}
                  alt={t(vendor.key)}
                  style={{
                    width: "150px",
                    height: "150px",
                    objectFit: "contain",
                    marginBottom: "1rem",
                  }}
                />
                <span>{t(vendor.key)}</span>
              </Card>
            ))
          ) : (
            <p className="no-results">{t("noVendors") || "No vendors found."}</p>
          )}
        </CardContainer>
      </section>

      <Footer />
    </>
  );
};

export default Vendors;
